import { Button, Divider, Stack, Title } from "@mantine/core";
import {
  getNodeDetails,
  nodeActions,
  nodeSecondaryActions,
} from "../flowSettings";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import Locked from "../../../../../../components/View/Locked";

const ActionsList = ({
  handleActionClick,
  noSecondary,
  isBranch,
  withEvent,
}) => {
  const lang = useLanguage((s) => s.language);

  return (
    <Stack p={"xs"} py={"md"}>
      <Title order={5} ta={"center"}>
        {isBranch ? lang.workflows.add_branch : lang.workflows.add_step}
      </Title>
      <Stack gap={"sm"}>
        {nodeActions.map((item) => (
          <Locked
            disableLock={item === "email"}
            buttonProps={{ size: "sm", radius: "sm" }}
            top={4}
            right={-8}
            key={item}
            iconOnly
            withStar
            starProps={{ size: "xs" }}
            starTop={-4}
            starLeft={-4}
          >
            {(isLocked) => (
              <Button
                key={item}
                disabled={isLocked}
                leftSection={getNodeDetails(item, { size: 24 }).icon}
                color={getNodeDetails(item).color}
                variant="outline"
                size="sm"
                w={"100%"}
                onClick={() => handleActionClick(item)}
                justify="start"
              >
                {getNodeDetails(item).label}
              </Button>
            )}
          </Locked>
        ))}
      </Stack>
      {withEvent && (
        <>
          <Divider my={8} />

          <Button
            leftSection={getNodeDetails("event", { size: 24 }).icon}
            color={getNodeDetails("event").color}
            variant="outline"
            size="sm"
            w={"100%"}
            onClick={() => handleActionClick("event")}
            justify="start"
          >
            {getNodeDetails("event").label}
          </Button>
        </>
      )}
      {!noSecondary && (
        <>
          <Divider my={8} />
          {nodeSecondaryActions.map((item) => (
            <Button
              key={item}
              leftSection={getNodeDetails(item, { size: 24 }).icon}
              color={getNodeDetails(item).color}
              variant="outline"
              size="sm"
              w={"100%"}
              onClick={() => handleActionClick(item)}
              justify="start"
            >
              {getNodeDetails(item).label}
            </Button>
          ))}
        </>
      )}
    </Stack>
  );
};

export default ActionsList;
